import React from "react"
import "./styles.scss"
import ShapeWave from "./save.svg"
const H2WithWave = props => {
  const { centerItems = true } = props
  return (
    <div
      className={`h2WithWave d-flex flex-column justify-content-center ${
        centerItems ? "align-items-center centerWave" : ""
      }`}
    >
      <h2>{props.title}</h2>
      <img src={ShapeWave} />
    </div>
  )
}

export const H1WithWave = props => {
  const { centerItems = true } = props

  return (
    <div
      className={`h2WithWave d-flex flex-column justify-content-center ${
        centerItems ? "align-items-center centerWave" : ""
      }`}
    >
      <h1>{props.title}</h1>
      <img src={ShapeWave} />
    </div>
  )
}

export default H2WithWave
